module.exports = _.minBy;